var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeatPress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 527.534 926.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 370.986,
    y1: 429.963,
    x2: 370.986,
    y2: 453.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 343.574,
    y1: 429.963,
    x2: 343.574,
    y2: 453.449,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 222.741,
    y1: 426.62,
    x2: 237.414,
    y2: 426.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 163.771,
    y1: 420.128,
    x2: 216.585,
    y2: 420.128,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 216.585,
    y1: 465.775,
    x2: 243.533,
    y2: 465.775,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 258.207,
    y1: 426.62,
    x2: 272.88,
    y2: 426.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 326.32,
    y1: 310.087,
    x2: 326.32,
    y2: 326.231,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 298.908,
    y1: 310.087,
    x2: 298.908,
    y2: 326.231,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 303.575,
    y1: 438.02,
    x2: 303.575,
    y2: 451.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 276.163,
    y1: 438.02,
    x2: 276.163,
    y2: 451.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 286.935,
    y1: 306.57,
    x2: 286.935,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7b299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5d8c1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Machnes_and_dividers"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 54.355,
    y: 595.616,
    width: 455.55,
    height: 330.232,
    rx: 14.682,
    ry: 14.682,
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 77.986,
    y: 610.004,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.421,
    y: 608.766,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(712.295 543.005) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.413,
    y: 610.004,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.848,
    y: 608.766,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(768.72 486.579) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 190.839,
    y: 610.004,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.274,
    y: 608.766,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(825.145 430.153) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 247.265,
    y: 610.004,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.7,
    y: 608.766,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(881.57 373.726) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 303.692,
    y: 610.004,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.127,
    y: 608.766,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(937.995 317.3) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 360.118,
    y: 610.004,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.553,
    y: 608.766,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(994.42 260.873) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 416.545,
    y: 610.004,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.979,
    y: 608.766,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1050.845 204.447) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 472.971,
    y: 610.004,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.406,
    y: 608.766,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1107.27 148.021) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 77.986,
    y: 663.233,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.421,
    y: 661.995,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(765.524 596.233) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.413,
    y: 663.233,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.848,
    y: 661.995,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(821.949 539.806) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 190.839,
    y: 663.233,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.274,
    y: 661.995,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(878.374 483.38) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 247.265,
    y: 663.233,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.7,
    y: 661.995,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(934.799 426.954) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 303.692,
    y: 663.233,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.127,
    y: 661.995,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(991.224 370.527) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 360.118,
    y: 663.233,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.553,
    y: 661.995,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1047.649 314.101) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 416.545,
    y: 663.233,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.979,
    y: 661.995,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1104.074 257.674) rotate(89.998)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 472.971,
    y: 663.233,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.406,
    y: 661.995,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1160.498 201.248) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 77.986,
    y: 716.462,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.421,
    y: 715.224,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(818.753 649.46) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.413,
    y: 716.462,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.848,
    y: 715.224,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(875.178 593.034) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 190.839,
    y: 716.462,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.274,
    y: 715.224,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(931.603 536.608) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 247.265,
    y: 716.462,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.7,
    y: 715.224,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(988.028 480.181) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 303.692,
    y: 716.462,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.127,
    y: 715.224,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1044.453 423.755) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 360.118,
    y: 716.462,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.553,
    y: 715.224,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1100.878 367.328) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 416.545,
    y: 716.462,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.979,
    y: 715.224,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1157.302 310.902) rotate(89.998)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 472.971,
    y: 716.462,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.406,
    y: 715.224,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1213.727 254.476) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 77.986,
    y: 769.691,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.421,
    y: 768.453,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(871.982 702.688) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.413,
    y: 769.691,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.848,
    y: 768.453,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(928.407 646.261) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 190.839,
    y: 769.691,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.274,
    y: 768.453,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(984.832 589.835) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 247.265,
    y: 769.691,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.7,
    y: 768.453,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1041.257 533.409) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 303.692,
    y: 769.691,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.127,
    y: 768.453,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1097.682 476.982) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 360.118,
    y: 769.691,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.553,
    y: 768.453,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1154.107 420.556) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 416.545,
    y: 769.691,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.979,
    y: 768.453,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1210.531 364.13) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 472.971,
    y: 769.691,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.406,
    y: 768.453,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1266.956 307.703) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 77.986,
    y: 822.92,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.421,
    y: 821.682,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(925.211 755.915) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.413,
    y: 822.92,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.848,
    y: 821.682,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(981.636 699.489) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 190.839,
    y: 822.92,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.274,
    y: 821.682,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1038.061 643.063) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 247.265,
    y: 822.92,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.7,
    y: 821.682,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1094.486 586.636) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 303.692,
    y: 822.92,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.127,
    y: 821.682,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1150.91 530.21) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 360.118,
    y: 822.92,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.553,
    y: 821.682,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1207.335 473.783) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 416.545,
    y: 822.92,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.979,
    y: 821.682,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1263.76 417.357) rotate(89.998)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 472.971,
    y: 822.92,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.406,
    y: 821.682,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1320.185 360.931) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 77.986,
    y: 876.149,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.421,
    y: 874.911,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(978.44 809.143) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.413,
    y: 876.149,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.848,
    y: 874.911,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1034.865 752.716) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 190.839,
    y: 876.149,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.274,
    y: 874.911,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1091.29 696.29) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 247.265,
    y: 876.149,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.7,
    y: 874.911,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1147.714 639.864) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 303.692,
    y: 876.149,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.127,
    y: 874.911,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1204.139 583.437) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 360.118,
    y: 876.149,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.553,
    y: 874.911,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1260.564 527.011) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 416.545,
    y: 876.149,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.979,
    y: 874.911,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1316.989 470.585) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 472.971,
    y: 876.149,
    width: 13.305,
    height: 35.311,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.406,
    y: 874.911,
    width: 12.433,
    height: 37.787,
    rx: 6.217,
    ry: 6.217,
    transform: "translate(1373.414 414.158) rotate(89.999)",
    fill: "#aa7552"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "505.842 579.754 62.499 579.754 43.034 538.09 419.645 538.09 505.842 579.754",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.499,
    y: 579.754,
    width: 443.344,
    height: 10.159,
    fill: "#f2c2a0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.499 579.754 62.499 589.914 43.034 546.71 43.034 538.09 62.499 579.754",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M262.329,625.578v4.742c0,.988-.163,1.948-.468,2.842-1.292,3.858-5.136,6.662-9.702,6.662h-109.338c-4.566,0-8.41-2.804-9.702-6.662-.305-.893-.468-1.853-.468-2.842v-4.742h129.677Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.647,
    y: 619.108,
    width: 16.687,
    height: 15.921,
    rx: 7.961,
    ry: 7.961,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.647,
    y: 619.108,
    width: 16.687,
    height: 15.921,
    rx: 7.961,
    ry: 7.961,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.862,633.162c-1.292,3.858-5.136,6.662-9.702,6.662h-109.338c-4.566,0-8.41-2.804-9.702-6.662h128.742Z",
    fill: "#b0b0b0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M432.491,625.578v4.742c0,.988-.163,1.948-.468,2.842-1.292,3.858-5.136,6.662-9.702,6.662h-109.338c-4.566,0-8.41-2.804-9.702-6.662-.305-.893-.468-1.853-.468-2.842v-4.742h129.677Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.809,
    y: 619.108,
    width: 16.687,
    height: 15.921,
    rx: 7.961,
    ry: 7.961,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.809,
    y: 619.108,
    width: 16.687,
    height: 15.921,
    rx: 7.961,
    ry: 7.961,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.023,633.162c-1.292,3.858-5.136,6.662-9.702,6.662h-109.338c-4.566,0-8.41-2.804-9.702-6.662h128.742Z",
    fill: "#333"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "37.88 3 37.88 926.77 0 667.15 0 111.61 37.88 3",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.88,
    y: 3,
    width: 19.499,
    height: 923.77,
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.512,134.566h0c-.188,.414-.34,.003-.34-.916v-34.166c0-.919,.152-2.06,.34-2.549h0c.189-.492,.342-.141,.342,.785v34.417c0,.926-.154,2.014-.342,2.43Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.553,121.319v-6.529c0-1.818,.299-4.031,.67-4.95l.579-1.432c.379-.938,.689-.198,.689,1.658v6.667c0,1.856-.31,4.083-.689,4.967l-.579,1.349c-.371,.866-.67,.089-.67-1.73Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.498,127.996h0c-.2,.441-.362,.028-.362-.921v-35.257c0-.948,.162-2.138,.362-2.66h0c.201-.524,.365-.175,.365,.781v35.524c0,.956-.164,2.09-.365,2.533Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.477,114.399v-6.737c0-1.876,.318-4.184,.714-5.162l.617-1.525c.404-.999,.734-.261,.734,1.655v6.883c0,1.917-.33,4.239-.734,5.181l-.617,1.437c-.395,.922-.714,.143-.714-1.733Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.681,120.991h0c-.214,.47-.386,.056-.386-.924v-36.42c0-.98,.173-2.223,.386-2.78h0c.215-.559,.389-.213,.389,.774v36.705c0,.987-.175,2.172-.389,2.644Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.592,107.025v-6.957c0-1.937,.339-4.347,.761-5.391l.658-1.628c.431-1.067,.784-.332,.784,1.648v7.113c0,1.981-.352,4.408-.783,5.413l-.658,1.534c-.422,.984-.761,.204-.761-1.733Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.083,113.506h0c-.229,.503-.413,.088-.413-.925v-37.662c0-1.013,.185-2.315,.413-2.91h0c.23-.598,.416-.257,.416,.765v37.968c0,1.021-.187,2.261-.416,2.766Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.918,99.152v-7.193c0-2.003,.363-4.524,.814-5.64l.704-1.741c.461-1.141,.839-.413,.839,1.637v7.36c0,2.049-.377,4.59-.839,5.666l-.704,1.641c-.451,1.052-.814,.274-.814-1.729Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.726,105.49h0c-.245,.539-.443,.124-.443-.925v-38.993c0-1.049,.198-2.414,.443-3.053h0c.246-.641,.447-.306,.447,.752v39.32c0,1.058-.2,2.356-.447,2.898Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.478,90.726v-7.445c0-2.073,.389-4.715,.872-5.911l.755-1.867c.495-1.224,.9-.504,.9,1.619v7.624c0,2.123-.405,4.787-.9,5.941l-.755,1.76c-.484,1.127-.872,.353-.872-1.72Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.637,96.884h0c-.263,.58-.476,.166-.476-.921V55.542c0-1.087,.213-2.522,.476-3.208h0c.265-.689,.48-.361,.48,.736v40.773c0,1.097-.215,2.46-.48,3.042Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.296,81.689v-7.715c0-2.148,.418-4.923,.937-6.208l.811-2.007c.532-1.317,.968-.608,.968,1.594v7.908c0,2.202-.435,5.002-.967,6.243l-.811,1.891c-.52,1.211-.937,.443-.937-1.706Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.847,87.622h0c-.284,.625-.513,.214-.513-.915V44.75c0-1.129,.229-2.64,.513-3.38h0c.285-.743,.518-.425,.518,.714v42.336c0,1.139-.232,2.573-.518,3.201Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.402,71.971v-8.006c0-2.229,.45-5.149,1.009-6.533l.874-2.163c.574-1.42,1.043-.727,1.043,1.56v8.214c0,2.287-.469,5.236-1.043,6.574l-.874,2.039c-.56,1.305-1.009,.546-1.009-1.684Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.39,77.624h0c-.307,.675-.554,.269-.554-.905V33.105c0-1.173,.248-2.769,.554-3.568h0c.308-.803,.56-.497,.56,.687v44.025c0,1.184-.251,2.697-.56,3.376Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.829,61.491v-8.32c0-2.317,.486-5.396,1.09-6.892l.945-2.338c.621-1.535,1.129-.863,1.129,1.516v8.544c0,2.379-.508,5.492-1.129,6.939l-.945,2.204c-.605,1.41-1.09,.664-1.09-1.653Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.512,191.293h0c-.188,.299-.34-.204-.34-1.123v-34.166c0-.919,.152-1.967,.34-2.342h0c.189-.377,.342,.067,.342,.993v34.417c0,.926-.154,1.921-.342,2.221Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.553,177.461v-6.529c0-1.818,.299-3.849,.67-4.542l.579-1.079c.379-.707,.689,.221,.689,2.078v6.667c0,1.856-.31,3.894-.689,4.547l-.579,.997c-.371,.64-.67-.32-.67-2.138Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.498,186.541h0c-.2,.319-.362-.193-.362-1.141v-35.257c0-.948,.162-2.04,.362-2.439h0c.201-.401,.365,.047,.365,1.003v35.524c0,.956-.164,1.991-.365,2.311Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.477,172.322v-6.737c0-1.876,.318-3.99,.714-4.727l.617-1.15c.404-.753,.734,.186,.734,2.102v6.883c0,1.917-.33,4.038-.734,4.734l-.617,1.062c-.395,.681-.714-.292-.714-2.168Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.681,181.475h0c-.214,.34-.386-.18-.386-1.159v-36.42c0-.98,.173-2.118,.386-2.545h0c.215-.428,.389,.024,.389,1.011v36.705c0,.987-.175,2.066-.389,2.407Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.592,166.845v-6.957c0-1.937,.339-4.141,.761-4.927l.658-1.227c.431-.804,.784,.145,.784,2.126v7.113c0,1.981-.352,4.193-.783,4.936l-.658,1.133c-.422,.727-.761-.259-.761-2.197Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.083,176.062h0c-.229,.364-.413-.164-.413-1.177v-37.662c0-1.013,.185-2.203,.413-2.659h0c.23-.458,.416-.003,.416,1.018v37.968c0,1.021-.187,2.147-.416,2.512Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.918,160.998v-7.193c0-2.003,.363-4.303,.814-5.144l.704-1.313c.461-.86,.839,.098,.839,2.147v7.36c0,2.049-.377,4.36-.839,5.155l-.704,1.212c-.451,.777-.814-.222-.814-2.225Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.726,170.265h0c-.245,.39-.443-.146-.443-1.195v-38.993c0-1.049,.198-2.294,.443-2.783h0c.246-.491,.447-.034,.447,1.024v39.32c0,1.058-.2,2.234-.447,2.626Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.478,154.741v-7.445c0-2.073,.389-4.479,.872-5.38l.755-1.407c.495-.923,.9,.044,.9,2.167v7.624c0,2.123-.405,4.541-.9,5.393l-.755,1.3c-.484,.833-.872-.178-.872-2.252Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.637,164.041h0c-.263,.419-.476-.124-.476-1.211v-40.42c0-1.087,.213-2.393,.476-2.919h0c.265-.528,.48-.069,.48,1.028v40.772c0,1.097-.215,2.329-.48,2.75Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.296,148.029v-7.715c0-2.148,.418-4.669,.937-5.637l.811-1.513c.532-.992,.968-.019,.968,2.183v7.908c0,2.202-.435,4.737-.967,5.653l-.811,1.397c-.52,.895-.937-.128-.937-2.276Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.847,157.342h0c-.284,.452-.513-.099-.513-1.227v-41.957c0-1.129,.229-2.501,.513-3.067h0c.285-.569,.518-.109,.518,1.029v42.336c0,1.139-.232,2.432-.518,2.886Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.402,140.811v-8.006c0-2.229,.45-4.875,1.009-5.919l.874-1.63c.574-1.07,1.043-.091,1.043,2.196v8.214c0,2.287-.469,4.95-1.043,5.938l-.874,1.506c-.56,.964-1.009-.069-1.009-2.299Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.39,150.112h0c-.307,.488-.554-.069-.554-1.242v-43.614c0-1.173,.248-2.618,.554-3.231h0c.308-.615,.56-.156,.56,1.028v44.025c0,1.184-.251,2.544-.56,3.035Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.829,133.028v-8.32c0-2.317,.486-5.1,1.09-6.228l.945-1.762c.621-1.157,1.129-.176,1.129,2.204v8.544c0,2.379-.508,5.183-1.129,6.252l-.945,1.628c-.605,1.041-1.09,0-1.09-2.317Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.512,248.019h0c-.188,.185-.34-.411-.34-1.33v-34.166c0-.919,.152-1.875,.34-2.135h0c.189-.262,.342,.276,.342,1.202v34.417c0,.926-.154,1.827-.342,2.013Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.553,233.604v-6.529c0-1.818,.299-3.667,.67-4.134l.579-.727c.379-.476,.689,.64,.689,2.497v6.667c0,1.856-.31,3.706-.689,4.128l-.579,.644c-.371,.413-.67-.728-.67-2.546Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.498,245.086h0c-.2,.197-.362-.413-.362-1.362v-35.257c0-.948,.162-1.941,.362-2.219h0c.201-.279,.365,.269,.365,1.225v35.524c0,.956-.164,1.891-.365,2.089Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.477,230.245v-6.737c0-1.876,.318-3.796,.714-4.292l.617-.774c.404-.507,.734,.633,.734,2.549v6.883c0,1.917-.33,3.838-.734,4.287l-.617,.686c-.395,.44-.714-.726-.714-2.602Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.681,241.959h0c-.214,.21-.386-.415-.386-1.395v-36.42c0-.98,.173-2.013,.386-2.309h0c.215-.298,.389,.261,.389,1.248v36.705c0,.987-.175,1.959-.389,2.17Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.592,226.666v-6.957c0-1.937,.339-3.934,.761-4.464l.658-.826c.431-.541,.784,.622,.784,2.603v7.113c0,1.981-.352,3.979-.783,4.459l-.658,.733c-.422,.47-.761-.723-.761-2.66Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.083,238.618h0c-.229,.225-.413-.416-.413-1.429v-37.662c0-1.013,.185-2.09,.413-2.407h0c.23-.318,.416,.251,.416,1.272v37.968c0,1.021-.187,2.033-.416,2.258Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.918,222.845v-7.193c0-2.003,.363-4.082,.814-4.649l.704-.884c.461-.579,.839,.609,.839,2.658v7.36c0,2.049-.377,4.131-.839,4.644l-.704,.784c-.451,.502-.814-.718-.814-2.721Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.726,235.04h0c-.245,.241-.443-.415-.443-1.464v-38.993c0-1.049,.198-2.174,.443-2.513h0c.246-.341,.447,.238,.447,1.296v39.32c0,1.058-.2,2.112-.447,2.354Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.478,218.755v-7.445c0-2.073,.389-4.242,.872-4.849l.755-.948c.495-.621,.9,.592,.9,2.715v7.624c0,2.123-.405,4.294-.9,4.845l-.755,.84c-.484,.538-.872-.71-.872-2.783Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.637,231.198h0c-.263,.259-.476-.414-.476-1.501v-40.42c0-1.087,.213-2.264,.476-2.629h0c.265-.367,.48,.224,.48,1.32v40.772c0,1.097-.215,2.198-.48,2.458Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.296,214.369v-7.715c0-2.148,.418-4.414,.937-5.067l.811-1.019c.532-.668,.968,.57,.968,2.773v7.908c0,2.202-.435,4.472-.967,5.064l-.811,.903c-.52,.578-.937-.699-.937-2.847Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.847,227.063h0c-.284,.279-.513-.411-.513-1.54v-41.957c0-1.129,.229-2.361,.513-2.755h0c.285-.395,.518,.206,.518,1.345v42.336c0,1.139-.232,2.29-.518,2.57Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.402,209.652v-8.006c0-2.229,.45-4.601,1.009-5.304l.874-1.098c.574-.721,1.043,.544,1.043,2.831v8.214c0,2.287-.469,4.664-1.043,5.303l-.874,.973c-.56,.623-1.009-.684-1.009-2.913Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.39,222.6h0c-.307,.301-.554-.407-.554-1.58v-43.614c0-1.173,.248-2.468,.554-2.893h0c.308-.428,.56,.184,.56,1.369v44.025c0,1.184-.251,2.391-.56,2.694Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.829,204.565v-8.32c0-2.317,.486-4.805,1.09-5.564l.945-1.187c.621-.779,1.129,.512,1.129,2.891v8.544c0,2.379-.508,4.873-1.129,5.564l-.945,1.052c-.605,.673-1.09-.664-1.09-2.981Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.512,304.746h0c-.188,.07-.34-.618-.34-1.537v-34.166c0-.919,.152-1.782,.34-1.928h0c.189-.147,.342,.484,.342,1.41v34.417c0,.926-.154,1.734-.342,1.804Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.553,289.746v-6.529c0-1.818,.299-3.485,.67-3.725l.579-.374c.379-.245,.689,1.06,.689,2.916v6.667c0,1.856-.31,3.517-.689,3.709l-.579,.292c-.371,.187-.67-1.136-.67-2.954Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.498,303.631h0c-.2,.075-.362-.634-.362-1.582v-35.257c0-.948,.162-1.843,.362-1.999h0c.201-.156,.365,.491,.365,1.447v35.524c0,.956-.164,1.791-.365,1.866Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.477,288.168v-6.737c0-1.876,.318-3.602,.714-3.858l.617-.399c.404-.261,.734,1.079,.734,2.996v6.883c0,1.917-.33,3.637-.734,3.84l-.617,.311c-.395,.199-.714-1.161-.714-3.037Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.681,302.443h0c-.214,.08-.386-.65-.386-1.63v-36.42c0-.98,.173-1.908,.386-2.074h0c.215-.167,.389,.498,.389,1.485v36.705c0,.987-.175,1.853-.389,1.933Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.592,286.487v-6.957c0-1.937,.339-3.727,.761-4l.658-.425c.431-.279,.784,1.099,.784,3.08v7.113c0,1.981-.352,3.764-.783,3.982l-.658,.332c-.422,.213-.761-1.187-.761-3.124Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.083,301.174h0c-.229,.085-.413-.667-.413-1.68v-37.662c0-1.013,.185-1.978,.413-2.156h0c.23-.178,.416,.504,.416,1.526v37.968c0,1.021-.187,1.919-.416,2.005Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.918,284.691v-7.193c0-2.003,.363-3.861,.814-4.153l.704-.455c.461-.298,.839,1.119,.839,3.169v7.36c0,2.049-.377,3.901-.839,4.134l-.704,.355c-.451,.227-.814-1.213-.814-3.216Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.726,299.814h0c-.245,.091-.443-.685-.443-1.734v-38.993c0-1.049,.198-2.053,.443-2.243h0c.246-.191,.447,.51,.447,1.568v39.32c0,1.058-.2,1.99-.447,2.082Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.478,282.77v-7.445c0-2.073,.389-4.005,.872-4.318l.755-.488c.495-.32,.9,1.14,.9,3.263v7.624c0,2.123-.405,4.048-.9,4.298l-.755,.381c-.484,.244-.872-1.241-.872-3.314Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.637,298.355h0c-.263,.098-.476-.704-.476-1.791v-40.42c0-1.087,.213-2.134,.476-2.339h0c.265-.206,.48,.516,.48,1.613v40.772c0,1.097-.215,2.066-.48,2.165Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.296,280.709v-7.715c0-2.148,.418-4.16,.937-4.496l.811-.524c.532-.344,.968,1.16,.968,3.362v7.908c0,2.202-.435,4.207-.967,4.475l-.811,.409c-.52,.262-.937-1.269-.937-3.418Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.847,296.784h0c-.284,.106-.513-.724-.513-1.852v-41.957c0-1.129,.229-2.222,.513-2.442h0c.285-.222,.518,.521,.518,1.66v42.336c0,1.139-.232,2.149-.518,2.255Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.402,278.493v-8.006c0-2.229,.45-4.327,1.009-4.689l.874-.565c.574-.371,1.043,1.18,1.043,3.467v8.214c0,2.287-.469,4.378-1.043,4.667l-.874,.441c-.56,.282-1.009-1.299-1.009-3.528Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.39,295.088h0c-.307,.114-.554-.744-.554-1.918v-43.614c0-1.173,.248-2.317,.554-2.555h0c.308-.24,.56,.525,.56,1.709v44.025c0,1.184-.251,2.238-.56,2.353Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.829,276.103v-8.32c0-2.317,.486-4.509,1.09-4.9l.945-.611c.621-.401,1.129,1.199,1.129,3.578v8.544c0,2.379-.508,4.564-1.129,4.877l-.945,.477c-.605,.305-1.09-1.328-1.09-3.645Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.512,361.472h0c-.188-.044-.34-.825-.34-1.744v-34.166c0-.919,.152-1.69,.34-1.721h0c.189-.032,.342,.693,.342,1.619v34.417c0,.926-.154,1.64-.342,1.596Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.553,345.889v-6.529c0-1.818,.299-3.303,.67-3.317l.579-.022c.379-.014,.689,1.479,.689,3.336v6.667c0,1.856-.31,3.329-.689,3.289l-.579-.061c-.371-.039-.67-1.544-.67-3.363Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.498,362.176h0c-.2-.047-.362-.854-.362-1.803v-35.257c0-.948,.162-1.744,.362-1.778h0c.201-.034,.365,.713,.365,1.669v35.524c0,.956-.164,1.692-.365,1.644Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.477,346.091v-6.737c0-1.876,.318-3.408,.714-3.423l.617-.023c.404-.015,.734,1.526,.734,3.443v6.883c0,1.917-.33,3.436-.734,3.393l-.617-.065c-.395-.041-.714-1.596-.714-3.472Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.681,362.927h0c-.214-.05-.386-.885-.386-1.865v-36.42c0-.98,.173-1.803,.386-1.839h0c.215-.036,.389,.735,.389,1.722v36.705c0,.987-.175,1.747-.389,1.696Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.592,346.307v-6.957c0-1.937,.339-3.521,.761-3.536l.658-.025c.431-.016,.784,1.577,.784,3.557v7.113c0,1.981-.352,3.55-.783,3.504l-.658-.069c-.422-.044-.761-1.65-.761-3.588Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.083,363.73h0c-.229-.054-.413-.919-.413-1.932v-37.662c0-1.013,.185-1.866,.413-1.904h0c.23-.039,.416,.758,.416,1.779v37.968c0,1.021-.187,1.805-.416,1.751Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.918,346.538v-7.193c0-2.003,.363-3.64,.814-3.657l.704-.026c.461-.017,.839,1.63,.839,3.68v7.36c0,2.049-.377,3.671-.839,3.623l-.704-.074c-.451-.047-.814-1.709-.814-3.712Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.726,364.589h0c-.245-.058-.443-.955-.443-2.004v-38.993c0-1.049,.198-1.933,.443-1.974h0c.246-.041,.447,.782,.447,1.84v39.32c0,1.058-.2,1.868-.447,1.81Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.478,346.784v-7.445c0-2.073,.389-3.768,.872-3.786l.755-.028c.495-.019,.9,1.687,.9,3.811v7.624c0,2.123-.405,3.802-.9,3.75l-.755-.079c-.484-.051-.872-1.772-.872-3.845Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.637,365.512h0c-.263-.062-.476-.994-.476-2.081v-40.42c0-1.087,.213-2.005,.476-2.049h0c.265-.045,.48,.808,.48,1.905v40.772c0,1.097-.215,1.935-.48,1.873Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.296,347.049v-7.715c0-2.148,.418-3.906,.937-3.925l.811-.03c.532-.02,.968,1.749,.968,3.951v7.908c0,2.202-.435,3.941-.967,3.886l-.811-.085c-.52-.054-.937-1.84-.937-3.989Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.847,366.505h0c-.284-.067-.513-1.036-.513-2.165v-41.957c0-1.129,.229-2.082,.513-2.13h0c.285-.048,.518,.836,.518,1.975v42.336c0,1.139-.232,2.007-.518,1.94Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.402,347.333v-8.006c0-2.229,.45-4.054,1.009-4.075l.874-.033c.574-.021,1.043,1.815,1.043,4.103v8.214c0,2.287-.469,4.092-1.043,4.032l-.874-.092c-.56-.059-1.009-1.913-1.009-4.143Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.39,367.576h0c-.307-.072-.554-1.082-.554-2.255v-43.614c0-1.173,.248-2.166,.554-2.218h0c.308-.052,.56,.866,.56,2.05v44.025c0,1.184-.251,2.085-.56,2.012Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.829,347.64v-8.32c0-2.317,.486-4.213,1.09-4.236l.945-.035c.621-.023,1.129,1.887,1.129,4.266v8.544c0,2.379-.508,4.255-1.129,4.19l-.945-.099c-.605-.063-1.09-1.993-1.09-4.309Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.512,418.199h0c-.188-.159-.34-1.032-.34-1.951v-34.166c0-.919,.152-1.597,.34-1.514h0c.189,.083,.342,.901,.342,1.827v34.417c0,.926-.154,1.547-.342,1.387Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.553,402.031v-6.529c0-1.818,.299-3.121,.67-2.909l.579,.331c.379,.217,.689,1.899,.689,3.755v6.667c0,1.856-.31,3.14-.689,2.87l-.579-.413c-.371-.265-.67-1.953-.67-3.771Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.498,420.721h0c-.2-.169-.362-1.075-.362-2.023v-35.257c0-.948,.162-1.646,.362-1.558h0c.201,.089,.365,.935,.365,1.891v35.524c0,.956-.164,1.592-.365,1.422Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.477,404.015v-6.737c0-1.876,.318-3.215,.714-2.989l.617,.352c.404,.231,.734,1.973,.734,3.89v6.883c0,1.917-.33,3.235-.734,2.946l-.617-.44c-.395-.282-.714-2.03-.714-3.906Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.681,423.411h0c-.214-.181-.386-1.121-.386-2.1v-36.42c0-.98,.173-1.698,.386-1.604h0c.215,.095,.389,.972,.389,1.959v36.705c0,.987-.175,1.64-.389,1.459Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.592,406.128v-6.957c0-1.937,.339-3.314,.761-3.073l.658,.376c.431,.247,.784,2.054,.784,4.035v7.113c0,1.981-.352,3.335-.783,3.027l-.658-.47c-.422-.301-.761-2.114-.761-4.052Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.083,426.286h0c-.229-.193-.413-1.17-.413-2.184v-37.662c0-1.013,.185-1.753,.413-1.652h0c.23,.101,.416,1.012,.416,2.033v37.968c0,1.021-.187,1.691-.416,1.497Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.918,408.384v-7.193c0-2.003,.363-3.419,.814-3.161l.704,.402c.461,.264,.839,2.141,.839,4.19v7.36c0,2.049-.377,3.442-.839,3.112l-.704-.503c-.451-.322-.814-2.205-.814-4.208Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.726,429.364h0c-.245-.207-.443-1.225-.443-2.273v-38.993c0-1.049,.198-1.812,.443-1.704h0c.246,.109,.447,1.054,.447,2.112v39.32c0,1.058-.2,1.746-.447,1.538Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.478,410.799v-7.445c0-2.073,.389-3.532,.872-3.255l.755,.431c.495,.283,.9,2.235,.9,4.358v7.624c0,2.123-.405,3.555-.9,3.202l-.755-.539c-.484-.345-.872-2.303-.872-4.377Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.637,432.668h0c-.263-.223-.476-1.284-.476-2.371v-40.42c0-1.087,.213-1.875,.476-1.759h0c.265,.117,.48,1.101,.48,2.198v40.772c0,1.097-.215,1.804-.48,1.58Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.296,413.389v-7.715c0-2.148,.418-3.651,.937-3.354l.811,.464c.532,.304,.968,2.338,.968,4.54v7.908c0,2.202-.435,3.676-.967,3.296l-.811-.579c-.52-.371-.937-2.411-.937-4.559Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.847,436.225h0c-.284-.24-.513-1.348-.513-2.477v-41.957c0-1.129,.229-1.943,.513-1.817h0c.285,.126,.518,1.151,.518,2.29v42.336c0,1.139-.232,1.866-.518,1.625Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.402,416.174v-8.006c0-2.229,.45-3.78,1.009-3.46l.874,.5c.574,.328,1.043,2.451,1.043,4.738v8.214c0,2.287-.469,3.806-1.043,3.396l-.874-.624c-.56-.4-1.009-2.528-1.009-4.758Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.39,440.065h0c-.307-.259-.554-1.42-.554-2.593v-43.614c0-1.173,.248-2.015,.554-1.88h0c.308,.136,.56,1.207,.56,2.391v44.025c0,1.184-.251,1.932-.56,1.672Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.829,419.178v-8.32c0-2.317,.486-3.917,1.09-3.572l.945,.54c.621,.355,1.129,2.574,1.129,4.953v8.544c0,2.379-.508,3.945-1.129,3.502l-.945-.675c-.605-.432-1.09-2.657-1.09-4.974Z",
    fill: "#7f5640"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.593,489.376h0c-.197-.311-.357-1.288-.357-2.182v-33.247c0-.894,.159-1.416,.356-1.165h0c.198,.252,.359,1.185,.359,2.084v33.446c0,.9-.16,1.376-.358,1.064Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.584,472.821v-6.362c0-1.771,.315-2.776,.705-2.242l.608,.832c.397,.543,.721,2.447,.721,4.249v6.471c0,1.802-.324,2.785-.721,2.199l-.608-.897c-.391-.576-.705-2.477-.705-4.249Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.709,494.283h0c-.208-.327-.376-1.336-.376-2.254l-.002-34.108c0-.917,.168-1.447,.375-1.184h0c.208,.265,.378,1.228,.378,2.151l.002,34.318c0,.924-.169,1.405-.378,1.077Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.647,477.26v-6.526c0-1.817,.331-2.837,.742-2.274l.639,.875c.418,.572,.759,2.538,.759,4.387v6.64c0,1.849-.34,2.845-.758,2.228l-.64-.944c-.411-.607-.742-2.569-.742-4.386Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.992,499.452h0c-.219-.345-.396-1.388-.396-2.33l-.003-35.015c0-.941,.177-1.48,.396-1.202h0c.22,.279,.398,1.274,.398,2.221l.004,35.236c0,.948-.179,1.436-.398,1.09Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.872,481.932v-6.698c0-1.865,.348-2.899,.781-2.307l.674,.922c.441,.603,.8,2.634,.801,4.533v6.819c.001,1.899-.358,2.908-.799,2.257l-.674-.995c-.433-.639-.782-2.666-.782-4.532Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.453,504.903h0c-.231-.364-.418-1.443-.418-2.411l-.005-35.971c0-.967,.186-1.514,.417-1.221h0c.232,.294,.421,1.323,.421,2.297l.006,36.204c0,.974-.188,1.467-.42,1.102Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.271,486.858v-6.88c-.001-1.916,.367-2.965,.823-2.339l.711,.974c.465,.637,.845,2.738,.845,4.689v7.007c.001,1.952-.378,2.973-.843,2.287l-.711-1.05c-.457-.674-.825-2.771-.826-4.687Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.11,510.66h0c-.244-.385-.442-1.502-.442-2.498l-.007-36.981c0-.994,.197-1.55,.441-1.24h0c.245,.311,.445,1.376,.445,2.377l.007,37.228c0,1.002-.199,1.5-.444,1.114Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.86,492.059v-7.072c-.002-1.969,.387-3.033,.87-2.372l.752,1.029c.492,.673,.894,2.849,.894,4.856l.002,7.207c0,2.007-.401,3.042-.893,2.316l-.752-1.11c-.483-.713-.872-2.883-.872-4.853Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.978,516.751h0c-.259-.407-.468-1.566-.468-2.591l-.009-38.05c0-1.023,.208-1.587,.467-1.259h0c.259,.33,.471,1.433,.471,2.463l.01,38.311c0,1.031-.211,1.534-.47,1.126Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.654,497.557l-.002-7.275c0-2.026,.411-3.104,.922-2.405l.796,1.089c.521,.713,.946,2.969,.947,5.034l.002,7.418c0,2.066-.424,3.113-.945,2.344l-.796-1.175c-.511-.754-.923-3.004-.923-5.03Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.076,523.204h0c-.274-.432-.496-1.636-.496-2.69l-.011-39.182c0-1.053,.221-1.626,.495-1.278h0c.275,.349,.499,1.494,.5,2.555l.012,39.458c0,1.062-.223,1.57-.499,1.137Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.672,503.379l-.002-7.49c0-2.085,.435-3.179,.977-2.438l.844,1.155c.552,.756,1.004,3.098,1.005,5.226l.002,7.641c0,2.128-.45,3.188-1.002,2.372l-.844-1.246c-.542-.8-.979-3.135-.979-5.221Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.426,530.053h0c-.291-.459-.527-1.71-.527-2.797l-.014-40.383c0-1.086,.234-1.667,.526-1.297h0c.292,.371,.53,1.56,.531,2.654l.015,40.677c0,1.095-.237,1.608-.53,1.147Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.934,509.555l-.003-7.718c0-2.149,.462-3.257,1.037-2.47l.897,1.227c.587,.804,1.067,3.238,1.068,5.432l.003,7.879c0,2.194-.478,3.266-1.065,2.399l-.897-1.324c-.575-.849-1.039-3.276-1.04-5.425Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.594,544.606h0c-.198-.402-.357-1.453-.357-2.349v-33.295c0-.895,.159-1.345,.357-1.003h0c.198,.343,.359,1.351,.359,2.252v33.494c0,.901-.16,1.304-.359,.901Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.585,527.565v-6.371c0-1.774,.315-2.636,.706-1.922l.608,1.111c.397,.726,.722,2.781,.722,4.586v6.48c0,1.805-.324,2.64-.721,1.871l-.608-1.177c-.391-.756-.706-2.804-.706-4.579Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.713,550.95h0c-.208-.423-.376-1.51-.376-2.429l-.002-34.158c0-.918,.168-1.373,.376-1.013h0c.209,.361,.378,1.403,.378,2.327l.002,34.368c0,.925-.17,1.33-.378,.905Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65,533.415v-6.535c0-1.82,.331-2.689,.742-1.937l.64,1.17c.418,.765,.76,2.889,.76,4.741v6.65c0,1.852-.341,2.693-.759,1.883l-.64-1.239c-.411-.796-.743-2.913-.743-4.733Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.998,557.631h0c-.219-.446-.396-1.571-.396-2.515l-.003-35.068c0-.943,.177-1.401,.396-1.022h0c.22,.38,.399,1.458,.399,2.407l.004,35.289c0,.95-.179,1.356-.399,.908Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.877,539.573v-6.708c0-1.868,.348-2.744,.782-1.952l.674,1.233c.441,.806,.801,3.005,.801,4.907v6.829c.001,1.902-.359,2.747-.8,1.894l-.675-1.305c-.433-.839-.783-3.029-.783-4.897Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.462,564.679h0c-.231-.471-.418-1.637-.419-2.606l-.005-36.027c0-.969,.187-1.431,.418-1.031h0c.232,.401,.421,1.518,.421,2.493l.006,36.261c0,.976-.189,1.383-.421,.911Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.279,546.065v-6.891c-.001-1.919,.367-2.801,.824-1.965l.712,1.301c.466,.851,.846,3.13,.846,5.084v7.018c.001,1.955-.378,2.804-.844,1.903l-.712-1.378c-.457-.885-.826-3.154-.826-5.073Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.122,572.122h0c-.245-.497-.442-1.707-.442-2.704l-.007-37.04c0-.996,.197-1.462,.442-1.039h0c.245,.424,.445,1.582,.445,2.584l.008,37.287c0,1.004-.199,1.411-.445,.912Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.871,552.919v-7.083c-.002-1.972,.387-2.86,.87-1.976l.752,1.375c.492,.9,.894,3.263,.895,5.273l.002,7.218c0,2.01-.401,2.862-.893,1.91l-.753-1.456c-.483-.935-.873-3.288-.873-5.261Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.993,579.997h0c-.259-.527-.468-1.784-.468-2.809l-.009-38.112c0-1.025,.209-1.494,.467-1.047h0c.26,.449,.471,1.651,.471,2.682l.01,38.374c0,1.033-.211,1.44-.471,.912Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.668,560.166l-.002-7.287c0-2.029,.411-2.921,.922-1.986l.797,1.456c.521,.953,.947,3.408,.948,5.476l.002,7.43c0,2.069-.425,2.923-.946,1.914l-.797-1.542c-.512-.99-.924-3.432-.924-5.462Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.095,588.341h0c-.275-.558-.497-1.866-.497-2.922l-.011-39.247c0-1.055,.221-1.527,.495-1.053h0c.275,.476,.5,1.725,.5,2.788l.012,39.525c0,1.064-.224,1.47-.499,.91Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.69,567.841l-.002-7.503c0-2.089,.435-2.984,.978-1.993l.845,1.544c.553,1.011,1.005,3.564,1.006,5.695l.002,7.654c0,2.132-.45,2.986-1.003,1.916l-.845-1.635c-.542-1.05-.979-3.588-.98-5.678Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.449,597.197h0c-.292-.593-.528-1.955-.528-3.044l-.014-40.453c0-1.088,.235-1.562,.526-1.058h0c.293,.506,.531,1.806,.531,2.901l.015,40.748c0,1.097-.238,1.501-.53,.906Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.956,575.982l-.003-7.731c0-2.153,.462-3.05,1.038-1.998l.898,1.64c.588,1.074,1.068,3.733,1.069,5.93l.003,7.893c0,2.198-.478,3.051-1.066,1.914l-.898-1.737c-.576-1.115-1.04-3.758-1.041-5.911Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.595,599.916h0c-.198-.493-.358-1.619-.358-2.517v-33.342c0-.897,.159-1.274,.357-.841h0c.198,.434,.36,1.518,.36,2.42v33.542c0,.903-.16,1.232-.359,.737Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.585,582.387v-6.38c0-1.776,.315-2.495,.706-1.601l.608,1.392c.398,.91,.722,3.116,.722,4.923v6.489c0,1.807-.324,2.495-.722,1.543l-.609-1.457c-.391-.937-.706-3.132-.706-4.909Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.716,607.7h0c-.208-.519-.376-1.685-.376-2.606l-.002-34.208c0-.92,.168-1.297,.376-.842h0c.209,.457,.379,1.579,.379,2.504l.002,34.419c0,.926-.17,1.254-.379,.733Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.653,589.652v-6.545c0-1.822,.331-2.541,.743-1.599l.64,1.465c.419,.958,.76,3.242,.76,5.097v6.66c0,1.855-.341,2.54-.759,1.537l-.641-1.534c-.412-.986-.743-3.258-.743-5.081Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.004,615.899h0c-.219-.547-.397-1.756-.397-2.701l-.003-35.12c0-.944,.177-1.322,.396-.842h0c.22,.482,.399,1.644,.399,2.594l.004,35.343c0,.951-.179,1.276-.399,.727Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.882,597.3v-6.718c0-1.871,.348-2.588,.782-1.596l.675,1.544c.441,1.01,.802,3.377,.802,5.282v6.84c.001,1.905-.359,2.586-.8,1.529l-.675-1.617c-.434-1.039-.783-3.393-.784-5.264Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.471,624.547h0c-.232-.577-.419-1.831-.419-2.802l-.005-36.082c0-.97,.187-1.347,.418-.841h0c.232,.508,.421,1.713,.421,2.69l.006,36.317c0,.977-.189,1.298-.421,.719Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.287,605.363v-6.901c-.001-1.921,.367-2.636,.825-1.589l.712,1.63c.466,1.066,.846,3.522,.847,5.48v7.029c.001,1.958-.379,2.634-.845,1.518l-.713-1.707c-.458-1.096-.827-3.538-.827-5.46Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.134,633.682h0c-.245-.61-.443-1.913-.443-2.912l-.007-37.099c0-.997,.197-1.374,.442-.838h0c.245,.537,.445,1.788,.446,2.793l.008,37.347c0,1.005-.199,1.322-.445,.709Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.882,613.876v-7.094c-.002-1.975,.388-2.685,.871-1.579l.753,1.723c.493,1.127,.895,3.679,.896,5.692l.002,7.23c0,2.013-.401,2.683-.894,1.502l-.753-1.804c-.484-1.159-.874-3.694-.874-5.669Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.009,643.346h0c-.259-.646-.469-2.001-.469-3.029l-.009-38.174c0-1.026,.209-1.401,.468-.834h0c.26,.569,.472,1.87,.472,2.903l.01,38.437c0,1.035-.211,1.345-.471,.697Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.682,622.877l-.002-7.299c0-2.032,.411-2.737,.923-1.566l.797,1.824c.522,1.194,.948,3.848,.949,5.92l.002,7.442c0,2.073-.425,2.733-.947,1.483l-.798-1.91c-.512-1.226-.925-3.862-.925-5.895Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.115,653.587h0c-.275-.685-.497-2.097-.497-3.155l-.011-39.313c0-1.057,.221-1.428,.496-.827h0c.276,.603,.5,1.957,.501,3.022l.012,39.592c0,1.066-.224,1.37-.5,.682Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.708,632.41l-.002-7.515c0-2.092,.436-2.789,.979-1.547l.846,1.934c.554,1.266,1.006,4.031,1.007,6.166l.002,7.667c0,2.135-.451,2.784-1.004,1.458l-.846-2.026c-.543-1.3-.98-4.044-.981-6.137Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.473,664.458h0c-.292-.728-.528-2.2-.528-3.291l-.014-40.523c0-1.09,.235-1.457,.527-.818h0c.293,.641,.532,2.052,.532,3.15l.015,40.819c0,1.099-.238,1.395-.531,.664Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.978,642.523l-.003-7.745c0-2.156,.463-2.843,1.039-1.524l.898,2.055c.588,1.346,1.069,4.229,1.07,6.431l.003,7.907c0,2.202-.479,2.836-1.067,1.427l-.899-2.152c-.577-1.381-1.041-4.241-1.042-6.398Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.596,655.304h0c-.198-.585-.358-1.786-.358-2.684v-33.39c0-.898,.159-1.202,.357-.678h0c.198,.526,.36,1.685,.36,2.589v33.591c0,.904-.161,1.16-.359,.573Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.586,637.287v-6.389c0-1.779,.315-2.354,.707-1.279l.609,1.673c.398,1.094,.723,3.452,.723,5.262v6.499c0,1.81-.324,2.35-.722,1.214l-.609-1.739c-.391-1.118-.707-3.461-.707-5.24Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.72,664.533h0c-.208-.615-.377-1.86-.377-2.782l-.002-34.258c0-.921,.168-1.222,.376-.671h0c.209,.553,.379,1.755,.379,2.682l.002,34.47c0,.928-.17,1.178-.379,.56Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.655,645.97v-6.554c0-1.825,.331-2.392,.743-1.26l.641,1.761c.419,1.151,.761,3.596,.761,5.453v6.67c0,1.857-.341,2.387-.76,1.191l-.641-1.831c-.412-1.176-.744-3.604-.744-5.429Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.01,674.254h0c-.22-.649-.397-1.94-.397-2.887l-.003-35.173c0-.946,.177-1.243,.397-.661h0c.22,.583,.399,1.829,.399,2.781l.004,35.396c0,.953-.179,1.196-.399,.545Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.887,655.113v-6.728c0-1.873,.349-2.431,.783-1.238l.676,1.856c.442,1.214,.802,3.75,.803,5.658v6.85c.001,1.908-.359,2.425-.801,1.163l-.676-1.929c-.434-1.24-.784-3.758-.784-5.631Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.48,684.508h0c-.232-.685-.419-2.026-.419-2.999l-.005-36.138c0-.972,.187-1.264,.418-.65h0c.232,.616,.422,1.909,.422,2.887l.006,36.374c0,.979-.189,1.214-.421,.527Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.295,664.752v-6.912c-.001-1.924,.368-2.471,.826-1.212l.713,1.959c.466,1.282,.847,3.916,.848,5.877v7.04c.001,1.961-.379,2.463-.845,1.131l-.713-2.037c-.458-1.308-.827-3.923-.828-5.848Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.146,695.34h0c-.245-.724-.443-2.119-.443-3.119l-.007-37.158c0-.999,.197-1.285,.442-.636h0c.246,.651,.446,1.996,.446,3.001l.008,37.407c0,1.007-.2,1.232-.445,.506Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.893,674.929v-7.106c-.002-1.978,.388-2.511,.872-1.181l.754,2.071c.493,1.355,.896,4.096,.896,6.112l.002,7.242c0,2.017-.402,2.502-.895,1.094l-.754-2.153c-.484-1.383-.874-4.1-.875-6.079Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.024,706.8h0c-.259-.766-.469-2.22-.469-3.249l-.009-38.236c0-1.028,.209-1.307,.468-.62h0c.26,.689,.472,2.089,.472,3.124l.01,38.5c0,1.036-.211,1.251-.472,.481Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.697,685.69l-.002-7.311c0-2.035,.412-2.552,.924-1.144l.798,2.193c.522,1.435,.949,4.289,.95,6.365l.002,7.455c0,2.076-.425,2.542-.948,1.05l-.798-2.28c-.513-1.464-.926-4.293-.926-6.329Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.134,718.944h0c-.275-.813-.498-2.329-.498-3.388l-.012-39.38c0-1.059,.221-1.329,.496-.601h0c.276,.731,.501,2.19,.501,3.256l.012,39.659c0,1.067-.224,1.269-.5,.453Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.726,697.087l-.002-7.528c0-2.096,.436-2.593,.98-1.1l.846,2.326c.554,1.523,1.007,4.499,1.008,6.638l.002,7.68c0,2.139-.451,2.581-1.005,.998l-.847-2.418c-.543-1.552-.981-4.501-.982-6.597Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.497,731.836h0c-.292-.864-.529-2.447-.529-3.539l-.014-40.593c0-1.091,.235-1.351,.527-.578h0c.293,.777,.532,2.3,.532,3.399l.015,40.89c0,1.101-.238,1.287-.531,.42Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.001,709.179l-.003-7.758c0-2.16,.463-2.635,1.04-1.049l.899,2.471c.589,1.618,1.07,4.727,1.071,6.933l.003,7.921c0,2.206-.479,2.621-1.068,.939l-.9-2.569c-.577-1.648-1.042-4.727-1.043-6.887Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.598,710.772h0c-.198-.677-.358-1.953-.358-2.853v-33.438c0-.899,.159-1.13,.357-.515h0c.199,.618,.36,1.853,.36,2.758v33.639c0,.905-.161,1.087-.359,.409Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.586,692.265v-6.398c0-1.781,.316-2.213,.707-.956l.609,1.955c.398,1.278,.723,3.789,.723,5.601v6.508c0,1.812-.324,2.204-.723,.883l-.609-2.021c-.392-1.299-.707-3.791-.707-5.573Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.723,721.45h0c-.208-.712-.377-2.036-.377-2.96l-.002-34.309c0-.923,.168-1.147,.377-.499h0c.209,.65,.379,1.931,.379,2.86l.002,34.521c0,.929-.17,1.101-.379,.387Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.658,702.371v-6.564c0-1.828,.332-2.243,.744-.921l.641,2.058c.419,1.346,.761,3.951,.762,5.811v6.68c0,1.86-.341,2.234-.761,.843l-.642-2.128c-.412-1.367-.745-3.951-.745-5.779Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.016,732.698h0c-.22-.751-.397-2.126-.397-3.074l-.003-35.226c0-.947,.177-1.163,.397-.48h0c.22,.685,.4,2.015,.4,2.969l.004,35.45c0,.954-.179,1.115-.4,.362Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.892,713.012v-6.738c0-1.876,.349-2.274,.783-.88l.676,2.17c.442,1.419,.803,4.125,.803,6.035v6.86c.001,1.911-.359,2.263-.802,.797l-.676-2.243c-.434-1.441-.785-4.123-.785-6Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.489,744.562h0c-.232-.792-.419-2.222-.42-3.196l-.005-36.194c0-.973,.187-1.18,.419-.459h0c.233,.723,.422,2.106,.422,3.085l.006,36.43c0,.98-.189,1.129-.422,.334Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.303,724.232v-6.922c-.001-1.927,.368-2.305,.826-.834l.714,2.29c.467,1.498,.848,4.312,.848,6.275v7.051c.001,1.964-.379,2.292-.846,.744l-.714-2.368c-.459-1.521-.828-4.309-.828-6.237Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.158,757.096h0c-.245-.838-.443-2.326-.444-3.328l-.007-37.217c0-1.001,.198-1.196,.443-.434h0c.246,.765,.446,2.204,.446,3.211l.008,37.466c0,1.008-.2,1.142-.446,.301Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.904,736.078v-7.117c-.002-1.982,.388-2.336,.873-.781l.754,2.421c.494,1.584,.897,4.514,.897,6.533l.002,7.253c0,2.02-.402,2.321-.896,.684l-.755-2.503c-.485-1.607-.875-4.509-.876-6.491Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.04,770.358h0c-.26-.887-.47-2.439-.47-3.47l-.009-38.299c0-1.03,.209-1.213,.469-.406h0c.26,.81,.472,2.309,.473,3.346l.01,38.563c0,1.038-.211,1.155-.472,.265Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.711,748.605l-.002-7.322c0-2.039,.412-2.366,.925-.72l.799,2.564c.523,1.678,.95,4.732,.95,6.811l.002,7.467c0,2.08-.426,2.35-.949,.615l-.799-2.65c-.513-1.701-.926-4.725-.927-6.764Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.154,784.412h0c-.275-.941-.498-2.561-.498-3.623l-.012-39.446c0-1.061,.222-1.229,.497-.373h0c.276,.859,.501,2.424,.502,3.492l.012,39.726c0,1.069-.224,1.168-.501,.224Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.744,761.873l-.002-7.54c0-2.099,.437-2.396,.981-.651l.847,2.719c.555,1.78,1.008,4.97,1.009,7.112l.002,7.694c0,2.143-.452,2.378-1.006,.537l-.848-2.811c-.544-1.804-.982-4.959-.983-7.059Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.521,799.331h0c-.293-.999-.529-2.694-.53-3.788l-.014-40.664c0-1.093,.235-1.245,.528-.336h0c.294,.913,.533,2.548,.533,3.65l.015,40.962c0,1.103-.238,1.18-.532,.177Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.023,775.95l-.003-7.772c0-2.164,.464-2.426,1.041-.572l.9,2.889c.59,1.892,1.072,5.227,1.072,7.437l.003,7.934c0,2.21-.48,2.404-1.07,.448l-.901-2.987c-.578-1.916-1.043-5.214-1.044-7.378Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.599,766.32h0c-.198-.769-.358-2.12-.358-3.021v-33.485c0-.9,.16-1.058,.358-.351h0c.199,.71,.36,2.021,.36,2.927v33.687c0,.907-.161,1.015-.36,.244Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.586,747.321v-6.407c0-1.784,.316-2.071,.708-.632l.61,2.238c.399,1.463,.724,4.127,.724,5.942v6.518c0,1.815-.325,2.058-.723,.552l-.61-2.304c-.392-1.481-.708-4.122-.708-5.906Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.727,778.45h0c-.209-.809-.377-2.213-.377-3.137l-.002-34.359c0-.924,.168-1.071,.377-.326h0c.209,.747,.379,2.108,.379,3.038l.002,34.572c0,.93-.17,1.025-.379,.213Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.661,758.854v-6.573c0-1.83,.332-2.094,.744-.58l.642,2.356c.42,1.54,.762,4.307,.762,6.169v6.69c0,1.863-.342,2.08-.761,.494l-.642-2.426c-.413-1.559-.745-4.299-.745-6.13Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.022,791.229h0c-.22-.853-.398-2.312-.398-3.261l-.003-35.279c0-.949,.177-1.083,.397-.298h0c.221,.788,.4,2.202,.4,3.157l.004,35.503c0,.956-.179,1.034-.4,.178Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.898,770.999v-6.748c0-1.879,.349-2.117,.784-.521l.677,2.484c.442,1.624,.804,4.5,.804,6.413v6.871c.001,1.914-.36,2.101-.802,.429l-.677-2.557c-.435-1.643-.785-4.49-.785-6.37Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.498,804.71h0c-.232-.9-.42-2.419-.42-3.394l-.005-36.25c0-.975,.187-1.095,.419-.267h0c.233,.832,.422,2.303,.422,3.284l.006,36.487c0,.982-.189,1.043-.422,.14Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.311,783.803v-6.933c-.001-1.93,.368-2.139,.827-.455l.714,2.622c.467,1.715,.849,4.708,.849,6.675v7.062c.001,1.967-.379,2.121-.847,.355l-.714-2.7c-.459-1.734-.829-4.696-.829-6.627Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.17,818.951h0c-.245-.952-.444-2.534-.444-3.537l-.007-37.276c0-1.002,.198-1.107,.443-.231h0c.246,.879,.447,2.412,.447,3.421l.008,37.526c0,1.01-.2,1.052-.446,.097Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.915,797.324v-7.128c-.002-1.985,.389-2.16,.873-.38l.755,2.772c.494,1.813,.898,4.933,.898,6.956l.002,7.265c0,2.023-.402,2.14-.897,.273l-.755-2.854c-.485-1.833-.876-4.918-.876-6.903Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.055,834.02h0c-.26-1.008-.47-2.659-.47-3.691l-.009-38.362c0-1.031,.209-1.118,.469-.191h0c.261,.931,.473,2.53,.473,3.569l.01,38.627c0,1.04-.212,1.06-.473,.048Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.726,811.622l-.002-7.334c0-2.042,.412-2.18,.926-.296l.8,2.935c.523,1.921,.951,5.177,.951,7.259l.002,7.479c0,2.083-.426,2.157-.95,.18l-.8-3.022c-.513-1.94-.927-5.159-.928-7.201Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.173,849.99h0c-.276-1.069-.498-2.794-.499-3.858l-.012-39.512c0-1.062,.222-1.129,.497-.145h0c.276,.988,.502,2.658,.502,3.728l.012,39.794c0,1.071-.224,1.066-.501-.007Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.762,826.767l-.002-7.553c0-2.103,.437-2.199,.981-.201l.848,3.113c.555,2.038,1.009,5.441,1.01,7.587l.002,7.707c0,2.146-.452,2.173-1.007,.075l-.848-3.206c-.544-2.057-.983-5.419-.984-7.523Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.545,866.944h0c-.293-1.136-.53-2.942-.53-4.038l-.014-40.734c0-1.095,.236-1.139,.528-.094h0c.294,1.049,.533,2.798,.534,3.901l.015,41.034c0,1.104-.238,1.072-.533-.068Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.045,842.836l-.003-7.785c0-2.168,.464-2.216,1.042-.094l.901,3.308c.59,2.166,1.073,5.729,1.074,7.942l.003,7.948c0,2.214-.48,2.187-1.071-.043l-.901-3.406c-.578-2.186-1.045-5.702-1.045-7.871Z",
    fill: "#7f5640"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "162.909 481.95 162.909 513.487 144.26 491.482 144.26 463.487 162.909 481.95",
    fill: "#5a5f62"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.298 513.732 163.298 513.943 162.909 513.487 162.909 481.95 163.298 513.732",
    fill: "#5a5f62"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.298 546.13 144.26 519.993 144.26 492.074 162.909 514.146 163.298 546.13",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.964 481.95 163.298 481.95 144.725 463.605 355 463.605 399.964 481.95",
    fill: "#5a5f62"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 370.986,
    cy: 447.864,
    rx: 8.391,
    ry: 10.909,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.162,
    y: 436.956,
    width: 54.824,
    height: 21.818,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 316.162,
    cy: 447.864,
    rx: 8.391,
    ry: 10.909,
    fill: "#70797c"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 222.741,
    y: 384.242,
    width: 14.673,
    height: 84.757,
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.771,
    y: 372.512,
    width: 52.814,
    height: 95.232,
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.585,
    y: 458.773,
    width: 26.948,
    height: 14.005,
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.207,
    y: 384.242,
    width: 14.673,
    height: 84.757,
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.496,
    cy: 321.214,
    rx: 8.391,
    ry: 10.909,
    fill: "#70797c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 326.32,
    cy: 321.214,
    rx: 8.391,
    ry: 10.909,
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.496,
    y: 310.305,
    width: 54.824,
    height: 21.818,
    fill: "url(#linear-gradient-8)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 216.585,
    y: 306.611,
    width: 59.578,
    height: 79.158,
    rx: 7.847,
    ry: 7.847,
    fill: "#70797c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.966,
    y: 306.611,
    width: 44.197,
    height: 79.158,
    rx: 7.847,
    ry: 7.847,
    fill: "#252b35"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262.571,331.212l20.071,53.185c6.413,16.994,14.592,31.833,24.131,43.783l9.467,11.86c2,2.506,2.505,7.251,1.15,10.802h0c-1.507,3.949-4.677,4.812-6.826,1.858l-18.699-25.702c-4.231-5.816-7.882-12.769-10.809-20.589l-25.331-67.664c-1.249-3.337-.621-7.782,1.381-9.774h0c1.879-1.869,4.285-.882,5.464,2.242Z",
    fill: "#9fa7aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.583,331.212l20.071,53.185c6.413,16.994,14.592,31.833,24.131,43.783l9.467,11.86c2,2.506,2.505,7.251,1.15,10.802h0c-1.507,3.949-4.677,4.812-6.826,1.858l-18.699-25.702c-4.231-5.816-7.882-12.769-10.809-20.589l-25.331-67.664c-1.249-3.337-.621-7.782,1.381-9.774h0c1.879-1.869,4.285-.882,5.464,2.242Z",
    fill: "#70797c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 303.575,
    cy: 447.864,
    rx: 8.391,
    ry: 10.909,
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.752,
    y: 436.956,
    width: 54.824,
    height: 21.818,
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 248.752,
    cy: 447.864,
    rx: 8.391,
    ry: 10.909,
    fill: "#70797c"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 163.299,
    y: 481.953,
    width: 237.056,
    height: 31.99,
    fill: "#70797c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.909,
    y: 481.95,
    width: 237.054,
    height: 31.993,
    fill: "#70797c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.299,
    y: 513.732,
    width: 35.244,
    height: 31.569,
    fill: "#70797c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.112,
    y: 513.732,
    width: 35.244,
    height: 31.569,
    fill: "#70797c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.267,316.216l56.318,1.322,.621,68.018h-12.794l-50.261-27.723v-35.644c0-3.355,2.761-6.052,6.115-5.973Z",
    fill: "#5a5f62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.413,385.557h52.708v-11.601l-13.97-50.747c-.922-3.349-3.968-5.67-7.442-5.67h-41.059c-3.247,0-5.589,3.112-4.691,6.232l14.454,50.184v11.601Z",
    fill: "#252b35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.284,
    y: 373.508,
    width: 52.837,
    height: 12.049,
    fill: "#5a5f62"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M527.534,306.57H46.336V0h28.667c3.521,.47,7.065,.93,10.608,1.34,53.942,6.28,110.739,1.74,166.184,3.64,19.369,.66,38.588,2.12,57.957,2.85,19.584,.73,39.297,.72,58.945,.71,25.618-.02,51.343-.04,76.596-1.97,16.127-1.23,32.425-3.25,48.595-2.12,6.163,.42,12.197,1.3,18.424,1.39,4.875,.06,10.049-.47,13.807-1.84l1.417,302.57Z",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(69.96 228.822)",
    fontFamily: "Lato-Black, Lato",
    fontSize: 31
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: ".14em"
  }, "HE"), /*#__PURE__*/React.createElement("tspan", {
    x: 50.529,
    y: 0,
    letterSpacing: ".069em"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 74.71,
    y: 0,
    letterSpacing: ".11em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    letterSpacing: ".14em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 42
  }, "PRESS"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatPress);
export default __webpack_public_path__ + "static/media/heat-press.23fb76b33f3752a0a00bcadb675c1710.svg";
export { ForwardRef as ReactComponent };